import React from "react";
import "./Report_Analysis_Sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { FixIDS } from "../../../../utils/fixIDS";
import { useSelector } from "react-redux";

const Report_Analysis_Sidebar = () => {

  const permissions = useSelector((state) => state.auth.permissions);
  const haveSamplePermission = permissions?.includes(
    FixIDS.sample_report.List
  );

  const haveInsPermission = permissions?.includes(
    FixIDS.instrument_report.List
  );

  const haveCustomPermission = permissions?.includes(
    FixIDS.customer_report.List
  );

  const havePersonPermission = permissions?.includes(
    FixIDS.personnel_report.List
  );

  const haveRepeatPermission = permissions?.includes(
    FixIDS.repetability_report.List
  );

  const haveQCPermission = permissions?.includes(
    FixIDS.quality_control_plan_report.List
  );

  const haveMeasurePermission = permissions?.includes(
    FixIDS.measurement_uncertainity_report.List
  );

  const haveValidityPermission = permissions?.includes(
    FixIDS.use_of_alternative_instrument_report.List
  );


  const haveComplainPermission = permissions?.includes(
    FixIDS.complaint_report.List
  );


  const haveNonWorkPermission = permissions?.includes(
    FixIDS.non_confirming_work_report.List
  );

  const haveInternalPermission = permissions?.includes(
    FixIDS.internal_audit_report.List
  );

  const haveExternalPermission = permissions?.includes(
    FixIDS.external_audit_report.List
  );

  const haveMetrologicPermission = permissions?.includes(
    FixIDS.metrological_traceability_report.List
  );

  const haveConsumeItemPermission = permissions?.includes(
    FixIDS.consumable_item_report.List
  );


  const reportAnalysis = [
    
    ...(haveSamplePermission ? [{ title: "Sample Report", link: "sample-report" }] : []),

    ...(haveInsPermission ? [{ title: "Instrument Report", link: "instrument-report" }] : []),

    ...(haveCustomPermission ? [{ title: "Customer Report", link: "customer-report" }]: []),

    ...(havePersonPermission ? [{ title: "Resource Requirement", link: "resource-requirement" }]: []),

    ...(haveRepeatPermission ? [{ title: "Process Requirement", link: "process-requirement" }] : []),
    
    ...(haveQCPermission ? [{ title: "Quality Control Plan Report", link: "quality-control-plan" }] : []),

     ...(haveMeasurePermission ? [{
      title: "Measurement Uncertainty Report",
      link: "measurement-uncertainty-report",
    }]: []),

    ...(haveValidityPermission ? [{ title: "Ensuring Validity Of Result", link: "validity-result" }] : []),
    
    ...(haveComplainPermission ? [{ title: "Complaint Report", link: "complaint-report" }]: []),

    ...(haveNonWorkPermission ? [{ title: "Non Confirming Work Report", link: "non-confirming-work" }]: []),

    ...(haveInternalPermission ? [{ title: "Management System Requirement", link: "management-system" }] : []),

    ...(haveExternalPermission ? [{ title: "External Audit Report", link: "external-audit-report" }] : []),
    
    ...(haveMetrologicPermission ? [{
      title: "Metrological Tracebility Report",
      link: "metrological-tracebility-report",
    }] : []),

    ...(haveConsumeItemPermission ? [{ title: "Consumable Item Report", link: "consumable-item-report" }] : []),
  ];

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="Report_Analysis_Sidebar common_sidemenu">
      <div className="common_white_card">
        <p className="common_section_heading">Report Analysis</p>

        <div className="menu_section">
          {reportAnalysis?.map((item) => {
            const isActive = location.pathname.includes(item.link);

            return (
              <button
                className={`menu_header ${isActive ? "active" : ""}`}
                onClick={() => {
                  navigate(item?.link);
                }}
              >
                {item?.title}
                <span className="arrow">
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Report_Analysis_Sidebar;
